module.exports = __webpack_public_path__ + "static/media/404b.ff1210e9.png";